import { RootState } from 'store/types';
import { CardPosition, CardUploadImage, InsuranceCardUpload, InsuranceFile } from './types';

export function getCardUploadImages(front: InsuranceFile, back?: InsuranceFile): CardUploadImage[] {
  const images: CardUploadImage[] = [];

  if (front.azureFileName) {
    images.push({ name: front.azureFileName, position: CardPosition.FRONT });
  }
  if (back?.azureFileName) {
    images.push({ name: back.azureFileName, position: CardPosition.BACK });
  }

  return images;
}

export function getInsuranceCards(
  type: string,
  front?: InsuranceFile,
  back?: InsuranceFile
): InsuranceCardUpload | null {
  if (front?.attachmentId) {
    return {
      images: getCardUploadImages(front, back),
      type
    } as InsuranceCardUpload;
  }

  return null;
}

export function mapInsuranceCards(state: RootState): InsuranceCardUpload[] {
  const cards: InsuranceCardUpload[] = [];
  const { insuranceFiles } = state.eVisit.insurance;
  const primary = getInsuranceCards(
    'Primary Insurance ID',
    insuranceFiles.primaryFront,
    insuranceFiles.primaryBack
  );
  const secondary = getInsuranceCards(
    'Secondary Insurance ID',
    insuranceFiles.secondaryFront,
    insuranceFiles.secondaryBack
  );
  if (primary) {
    cards.push(primary);
  }
  if (secondary) {
    cards.push(secondary);
  }
  return cards;
}
